<template>
  <div class="opportunity-status-type">
    <BaseIcon v-if="isOpened" name="circle" />
    <BaseIcon v-else name="check-circle" class="is-closed" />
    <span v-if="!condensed">
      {{ isOpened ? $t('page.admin-opportunity-management.open') : $t('page.admin-opportunity-management.closed') }}
    </span>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'OpportunityStatusType',
  components: { BaseIcon },
  props: {
    opportunityStatus: {
      type: Object,
      required: true,
    },
    condensed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpened() {
      return this.opportunityStatus.statusType === 'open';
    },
  },
};
</script>

<style scoped lang="scss">
.opportunity-status-type {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  .base-icon.is-closed {
    color: $color-warm-blue;
  }

  .base-icon {
    color: $color-green;
    width: 18px;
    height: 18px;
  }
}
</style>
